module.exports = __webpack_public_path__ + "static/media/ror-social.365891f3.png";